import Element from "element-ui";
import locale from "element-ui/lib/locale/lang/en";
import "es6-promise/auto";
import _ from "lodash";
import vClickOutside from "v-click-outside";
import Vue from "vue";
import VueFloatLabel from "vue-float-label";
import Fullscreen from "vue-fullscreen";
import VueGoodTable from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import VueI18n from "vue-i18n";
import { default as VueLazyload, default as VueLazyLoad } from "vue-lazyload";
import VueResize from "vue-resize";
import "vue-resize/dist/vue-resize.css";
import VirtualList from "vue-virtual-scroll-list";
import Vuebar from "vuebar";
// import * as VueGoogleMaps from 'vue2-google-maps'
import { StatusIndicator } from "vue-status-indicator";
//import 'vue-status-indicator/styles.css'
import "flex.box";
import "../../node_modules/animate.css/animate.css";
import VuePerfectScrollbar from "./components/vue-ps/index";
// import 'flag-icon-css/css/flag-icon.css'
import PDFObject from "pdfobject";
import VeeValidate from "vee-validate";
import "../../node_modules/@mdi/font/scss/materialdesignicons.scss";
import Affix from "./directives/affix";
import i18n_messages from "./i18n.json";
import router from "./router/";
import store from "./store";

import VueToastr from "@deveodk/vue-toastr";
import html2canvas from "html2canvas";
import printJS from "print-js";
import money from "v-money";
import Viewer from "v-viewer";
import VueLocalStorage from "vue-localstorage";
import VueProgressBar from "vue-progressbar";
import Utils from "./utils";
// You need a specific loader for CSS files like https://github.com/webpack/css-loader
// If you would like custom styling of the toastr the css file can be replaced
import "@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css";
import VueCookies from "vue-cookies";
import LoadScript from "vue-plugin-load-script";
import Bus from "./bus";

require("./bowser");
require("./sentry");

// Global error handlers to prevent unwanted CORS/network errors from cluttering the console
window.addEventListener("unhandledrejection", function (event) {
    const error = event.reason;
    if (error && typeof error === "object") {
        const message = error.message || error.toString();
        const networkPatterns = [
            /cors/i,
            /cross-origin/i,
            /same.origin.policy/i,
            /failed.to.fetch/i,
            /network.error/i,
            /load.failed/i,
            /loading.chunk.*failed/i,
            /chunklisterror/i,
            /securityerror/i,
            /permission.denied/i,
            /blocked.*content.security.policy/i,
            /script.error/i
        ];

        const isNetworkError = networkPatterns.some((pattern) =>
            pattern.test(message)
        );

        if (isNetworkError) {
            console.debug("Suppressed network/CORS error:", message);
            event.preventDefault();
            return;
        }
    }
});

window.addEventListener("error", function (event) {
    const message = event.message || "";
    const networkPatterns = [
        /cors/i,
        /cross-origin/i,
        /same.origin.policy/i,
        /failed.to.fetch/i,
        /network.error/i,
        /script.error/i
    ];

    const isNetworkError = networkPatterns.some((pattern) =>
        pattern.test(message)
    );

    if (isNetworkError) {
        console.debug("Suppressed network/CORS error:", message);
        event.preventDefault();
        return;
    }
});

if (window.$ === undefined || window.jQuery === undefined) {
    window.$ = window.jQuery = require("jquery");
}
const queue = require("queue");

let q = queue({
    autostart: true,
    concurrency: 1
});

window.queue = {
    push(fn) {
        q.push((cb) => {
            let request = fn();
            if (!request) {
                console.warn("pushed to queue returns nothing!");
                cb();
                return;
            }
            request
                .catch((err) => {
                    console.log(err);
                    return err;
                })
                .finally(() => {
                    cb();
                });
        });
    }
};

require("jquery-timepicker/jquery.timepicker");

window.html2canvas = html2canvas;

window.printJS = printJS;
window._ = _;
window.uniqid = require("uniqid");

window.PDFObject = PDFObject;

window.Vue = Vue;
Vue.config.productionTip = false;

Vue.use(VeeValidate, {
    aria: true,
    classNames: {},
    classes: false,
    delay: 0,
    dictionary: null,
    errorBagName: "veeErrors", // change if property conflicts
    events: "input|blur",
    fieldsBagName: "veeFields",
    i18n: null, // the vue-i18n plugin instance
    i18nRootKey: "validations", // the nested key under which the validation messages will be located
    inject: true,
    locale: "en",
    validity: false
});

Vue.use(VueLocalStorage, {
    name: "ls"
});

Vue.component("StatusIndicator", StatusIndicator);
Vue.use(VueFloatLabel);
// Vue.use(VirtualCollection)
Vue.use(VueResize);
Vue.use(Fullscreen);
Vue.use(VueI18n);
Vue.use(Element, { locale });
// Vue.use(VueHighlightJS)
Vue.use(vClickOutside);
// Vue.use(Viewer)
Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgNjAwIDYwMCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iNjAwIiBoZWlnaHQ9IjYwMCIgc3R5bGU9ImZpbGw6I2UyZTNlNTsiLz48Y2lyY2xlIGN4PSIzMDAiIGN5PSIzMDAiIHI9IjE1NSIgc3R5bGU9ImZpbGw6bm9uZTtzdHJva2Utd2lkdGg6NDdweDtzdHJva2U6I2JjYmRiZjsiLz48cmVjdCB4PSIxNjAiIHk9IjIyMyIgd2lkdGg9IjI3NSIgaGVpZ2h0PSIxNjYiIHN0eWxlPSJmaWxsOiNlM2U1ZTQ7Ii8+PHBhdGggZD0iTTQ0MC41LDM5NC41bC0yODYsMGwwLC0xNzdsMjg2LDBsMCwxNzdaTTE2NS41LDIyOC41bDAsMTU1bDI2NCwwbDAsLTE1NWwtMjY0LDBaIiBzdHlsZT0iZmlsbDojZmZmOyIvPjxwYXRoIGQ9Ik00MDQuNDM0LDE3MC44NzdsLTIzMi45NCwyMzIuOTQxbDM1LjM1NSwzNS4zNTVsMjMyLjk0MSwtMjMyLjk0bC0zNS4zNTYsLTM1LjM1NloiIHN0eWxlPSJmaWxsOiNiY2JkYmY7Ii8+PC9zdmc+",
    loading:
        "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwcHgiICBoZWlnaHQ9IjEwMHB4IiAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQiIGNsYXNzPSJsZHMtcmlwcGxlIiBzdHlsZT0iYmFja2dyb3VuZDogbm9uZTsiPjxjaXJjbGUgY3g9IjUwIiBjeT0iNTAiIHI9IjI4LjY2ODUiIGZpbGw9Im5vbmUiIG5nLWF0dHItc3Ryb2tlPSJ7e2NvbmZpZy5jMX19IiBuZy1hdHRyLXN0cm9rZS13aWR0aD0ie3tjb25maWcud2lkdGh9fSIgc3Ryb2tlPSIjNGE1OTZhIiBzdHJva2Utd2lkdGg9IjIiPjxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9InIiIGNhbGNNb2RlPSJzcGxpbmUiIHZhbHVlcz0iMDszMCIga2V5VGltZXM9IjA7MSIgZHVyPSIyIiBrZXlTcGxpbmVzPSIwIDAuMiAwLjggMSIgYmVnaW49Ii0xcyIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiPjwvYW5pbWF0ZT48YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJvcGFjaXR5IiBjYWxjTW9kZT0ic3BsaW5lIiB2YWx1ZXM9IjE7MCIga2V5VGltZXM9IjA7MSIgZHVyPSIyIiBrZXlTcGxpbmVzPSIwLjIgMCAwLjggMSIgYmVnaW49IjBzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSI+PC9hbmltYXRlPjwvY2lyY2xlPjwvc3ZnPg==",
    attempt: 1
});
Vue.directive("affix", Affix);
Vue.use(Vuebar);
Vue.use(VueGoodTable);

Vue.use(VueProgressBar, {
    color: "#fdc849",
    failedColor: "red",
    thickness: "3px"
});

Vue.use(VueLazyLoad);

// Vue.use(V2Table)
Vue.component("vue-scroll", VuePerfectScrollbar);
Vue.component("vue-virtual-list", VirtualList);
const i18n = new VueI18n({ locale: "us", messages: i18n_messages });

Vue.use(money, { precision: 2 });

require("./axios");

window.Utils = Utils;

require("./forms/bootstrap");
require("./filters");
require("./mixin");

Vue.component("form-feedback", require("./components/forms/Feedback").default);
Vue.component("full-calendar", require("./components/FullCalendar").default);
Vue.component("color-picker", require("./components/ColorPicker").default);
Vue.component(
    "state-select",
    require("./components/forms/StateSelect").default
);
Vue.component(
    "custom-color-picker",
    require("./components/CustomColorPicker").default
);

require("slick-carousel/slick/slick");

Vue.use(Viewer, {
    defaultOptions: {
        inline: true,
        button: false,
        navbar: false,
        title: true,
        toolbar: true,
        tooltip: true,
        movable: true,
        zoomable: true,
        rotatable: true,
        scalable: true,
        transition: true,
        fullscreen: true,
        keyboard: true,
        url: "data-source"
    }
});

Vue.use(VueToastr);

Vue.use(LoadScript);

window.moment = require("moment-recur");
window.moment_timezone = require("moment-timezone");

window.Bus = Bus;
Vue.component("app-card", require("./components/Card").default);
Vue.component("app-pagination", require("./components/Pagination").default);

Vue.use(VueCookies);

new Vue({
    i18n,
    router,
    store,
    render: (h) => h(require("./App.vue").default),
    created() {
        this.$Progress.start();
        this.$router.beforeEach((to, from, next) => {
            if (to.meta.progress !== undefined) {
                let meta = to.meta.progress;
                this.$Progress.parseMeta(meta);
            }
            this.$Progress.start();
            next();
        });
        this.$router.afterEach((to, from) => {
            this.$Progress.finish();
        });
    }
}).$mount("#app");
